// extracted by mini-css-extract-plugin
module.exports = {"container":"product-showcase_container__pbb9X","text-column":"product-showcase_text-column__lsGrq","image-column":"product-showcase_image-column__tm_Xh"};